var EmployerTypeApp = new (Backbone.Router.extend({
    Models: {},
    Views: {},
    Collections: {},
    Variables: {},
    Templates: {},

    routes: {
        "admin/employer-type": "startEmployerTypePage"
    },

    startEmployerTypePage: function() {
        var override = new EmployerTypeApp.Models.Override();
        new EmployerTypeApp.Views.Override({ model: override });
    }
}));